import React from "react";
import { MuiTelInput, MuiTelInputProps } from "mui-tel-input";
import { SxProps, Theme, useTheme } from "@mui/material";
import { tokens } from "../../theme";

type PhoneNumberFieldProps = MuiTelInputProps & {
  sx?: SxProps<Theme>;
};

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  sx,
  ...props
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MuiTelInput
      defaultCountry="ZW"
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "10px",
          "& fieldset": { border: `1px solid ${colors.primary[300]}` },
          "&.Mui-focused fieldset": { borderColor: "#614438" },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default PhoneNumberField;
